import { ArrowDownRight } from "lucide-react";
import { HERO_IMAGE, buildWhatsAppUrl } from "../data/watches";

export const Hero = () => {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative w-full h-[100svh] min-h-[600px] overflow-hidden grain"
    >
      <img
        src={HERO_IMAGE}
        alt="Reloj de lujo Romero Watches"
        className="absolute inset-0 w-full h-full object-cover object-[30%_center] sm:object-center hero-kenburns"
        loading="eager"
      />

      <div className="absolute inset-0 hero-mask" />
      <div className="absolute inset-0 bg-gradient-to-r from-[#050B14]/70 via-transparent to-[#050B14]/40" />

      <div className="relative z-10 h-full max-w-7xl mx-auto px-6 sm:px-12 flex flex-col justify-center pt-24 sm:pt-28 pb-12 sm:pb-16 lg:pb-20">
        <div className="max-w-3xl">
          <div className="drift inline-flex items-center gap-3 mb-10 sm:mb-8 flex-wrap">
            <span className="w-8 sm:w-10 h-px bg-[var(--brand-gold)] shrink-0" />
            <span className="font-accent-rw text-[9px] sm:text-[11px] uppercase tracking-[0.22em] sm:tracking-[0.4em] leading-relaxed text-[var(--brand-gold)] whitespace-nowrap">
              LATAM · Envíos a todo el mundo
            </span>
          </div>

          <h1
            data-testid="hero-title"
            className="font-serif-rw text-[2.75rem] sm:text-6xl lg:text-7xl xl:text-[5.5rem] font-light leading-[0.95] tracking-tight text-slate-50"
          >
            El arte de llevar
            <br />
            <span className="italic text-[var(--brand-gold)]">el tiempo.</span>
          </h1>

          <p className="mt-10 max-w-xl text-base sm:text-lg text-slate-300/90 leading-relaxed font-light">
            Relojería mecánica premium, seleccionada con obsesión. Movimientos
            automáticos japoneses, cristal de zafiro y acero 316L en cada
            pieza. Modelos originales de Pagani Design, Wishdoit, Berny y
            Specht & Söhne — incluyendo{" "}
            <span className="text-[var(--brand-gold)]">
              modelos para buceo profesional originales
            </span>{" "}
            con resistencia 200m.
          </p>

          <div className="mt-12 flex flex-col sm:flex-row gap-4 sm:gap-6">
            <a
              href="#coleccion"
              data-testid="hero-cta-button"
              className="group inline-flex items-center justify-center gap-3 px-8 py-4 border border-[var(--brand-gold)] text-[var(--brand-gold)] hover:bg-[var(--brand-gold)] hover:text-[var(--brand-bg)] transition-all duration-500 text-[11px] uppercase tracking-[0.28em] font-medium"
            >
              Ver colección
              <ArrowDownRight
                size={16}
                className="transition-transform duration-500 group-hover:translate-x-1 group-hover:translate-y-1"
              />
            </a>
            <a
              href={buildWhatsAppUrl()}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="hero-whatsapp-button"
              className="inline-flex items-center justify-center gap-3 px-8 py-4 text-slate-200 hover:text-[var(--brand-gold)] transition-all duration-300 text-[11px] uppercase tracking-[0.28em]"
            >
              <span className="w-1.5 h-1.5 rounded-full bg-[var(--brand-whatsapp)] animate-pulse" />
              Pedir por WhatsApp
            </a>
          </div>
        </div>

        <div className="mt-10 hidden sm:flex items-end justify-between text-slate-400/70 font-accent-rw text-[10px] uppercase tracking-[0.32em]">
          <span>Acero 316L · Zafiro · Automático japonés</span>
          <span className="hidden lg:inline">Garantía oficial 12 meses</span>
          <span>Resistentes al agua · WR</span>
        </div>
      </div>
    </section>
  );
};

export default Hero;
